export default {
  styles: null,
  value: null,
  transfer: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  choiceSideModalTitle: {
    type: String,
    default: '选择注册证号',
  },
  sideModalWidth: {
    type: String,
    default: '50%',
  },
  urlQuery: {
    type: String,
    default: '',
  },
  tableColumnDefUrl: {
    type: String,
    default: '',
  },
  draggableOfHeader: {
    type: Boolean,
    default: false,
  },
  draggable: {
    type: Boolean,
    default: false,
  },
  chooseRequestMethod: {
    type: String,
    default: 'post',
  },
  goodsId: {
    type: String,
    default: null,
  },
  chooseRequestParam: {
    type: [String, Object],
    default: () => {},
  },
  criteriaFormUrl: {
    type: String,
    default: '',
  },
  showKey: {
    type: String,
    default: 'code',
  },
  showKeyLeftFlag: {
    type: Boolean,
    default: false,
  },
  showKeySubFlag: {
    type: Boolean,
    default: false,
  },
  showKeySubFlagTwo: {
    type: Boolean,
    default: false,
  },
  showKeySubtitle: {
    type: String,
    default: 'code',
  },
  showKeySubtitleTwo: {
    type: String,
    default: 'number',
  },
  showAbleClearText: {
    type: Boolean,
    default: true,
  },
  //字段得宽度是否计算
  computWidth: {
    type: Boolean,
    default: true,
  },
  registrationWidth: {
    type: String,
    default: '250',
  },
  placeholder: {
    type: String,
    default: '证照类型',
  },
  showOfSearchInput: {
    type: Boolean,
    default: false,
  },
  //
  searchKey: {
    type: String,
    default: 'keyword',
  },
  needScaleData: {
    // 是否需要弹窗填写换算比例数据
    type: Boolean,
    default: false,
  },
  begFormData: {
    // queryGroup查询组绑定的数据
    type: Object,
  },
  rowData: {
    // 用于映射管理 传入表格对应行数据
    type: Object,
  },
  iconSelection: {
    // 是否开启加号添加模式
    type: Boolean,
    default: false,
  },
  showAllIconSelection: {
    // 是否开启加号批量添加模式
    type: Boolean,
    default: false,
  },
  btnIsGrayed: {
    // 置灰标识符
    type: String,
    default: 'disabled',
  },
  topTabs: {
    // 顶部tabs,需要传一个数组
    type: Array,
    default: () => {
      return null
      // 样例参数
      /* [{
                tagTitle:'客户', // 名称
                parameters:{} // 点击tag 查询参数
            }] */
    },
  },
  tabCode: { type: String, default: 'tabCode' },
  tabCodeTarget: { type: String },

  /* 侧滑表单的相关配置 */
  // 选择按钮的默认显示文本
  selectBtnText: {
    type: String,
    default: '选择',
  },
  showSelectBtn: {
    // 是否显示"选择"按钮
    type: Boolean,
    default: true,
  },
  ifRefreshData: {
    // 是否可以刷新数据
    type: Boolean,
    default: false,
  },
  formItemsDef: {
    // 表单侧滑配置的表单项
    type: Array,
    default: () => [],
  },
  formItemDefUrl: {
    // 表单配置url
    type: String,
    default: '',
  },
  formSideModalWidth: {
    // 表单侧滑的宽度
    type: String,
    default: '450',
  },
  formTitle: {
    // 表单侧滑的标题
    type: String,
    default: '新建',
  },
  topAddDes: {
    // 侧滑顶部提示信息描述
    type: String,
    default: '',
  },
  topMessage: {
    // 可编辑表单顶部提示信息
    type: String,
    default: '',
  },
  saveUrl: {
    // 表单确认按钮提交URL
    type: String,
    default: '',
  },
  saveMethod: {
    // 表单确定按钮请求方法
    type: String,
    default: 'get',
  },
  saveParamter: {
    // 表单确定按钮请求参数
    type: Object,
    default: () => ({}),
  },
  refreshUrl: {
    // 刷新选择的数据URL
    type: String,
    default: '',
  },
  dataIndex: {
    type: Number,
    default: -1,
  },
  // 4037 采购计划单 表格列 选择供应商
  // 场景：选择供应商后，将此组件所在行数据传给后台去做请求
  rowClickRequest: {
    type: Object,
    default: () => {
      return {
        url: '',
        method: 'post',
        params: {},
        requestCode: '4037', //需求编号，定制化开发
        // 针对 4037 当前组件所在表格的属性，用于修改数据，主要是由于，
        //请求的时候，还没有为组件赋值，因为如果要触发dispatchComponent的话，就不用多渲染一次了
        field: '',
      }
    },
  },
  // 触发父组件的事件
  dispatchComponent: {
    type: Object,
    default: null,
  },
  store: {
    type: Object,
    default: null,
  },
  // value 的取值路径
  valuePathKey: {
    type: String,
    default: null,
  },
  // 联动的表单项编码，配合监听的事件 registrationSelection.formData.items.disabled
  relactionCode: {
    type: String,
  },
  //是否显示 选择供应商时自动带入价格 需求8358
  isShowPrice: {
    type: Boolean,
    default: false,
  },
  // 将选择的数据保存在localStorge
  setLocalStorageSelectPrice: {
    type: String,
    default: 'ilnk-pending-plan-purchase-registrationSelection-cooperation',
  },
}
